import { getCurrentInstance } from 'vue'
import { store } from '@/store'
export const useStore = () => {
    const vm = getCurrentInstance()
    if (!vm) {
        return store
    }
    return vm.proxy.$store
}
